import AbstractAccountGroupRowTemplate from "./AbstractAccountGroupRowTemplate.js";
import GeneratedAccountGroupRow from "../../reports/rows/GeneratedAccountGroupRow.js";

/**
 * Template class for generated account group rows.
 * Generated account group row cannot store their additional child themselves, so they are stored
 * in the first non-generated account group row in their parent chain.
 */
export default class GeneratedAccountGroupRowTemplate extends AbstractAccountGroupRowTemplate {
	rootAccountGroupRowTemplate() {
		return this._parent.rootAccountGroupRowTemplate();
	}

	canHaveChildren() {
		return false;
	}

	isExcluded() {
		return this._excluded;
	}

	setExcluded(state) {
		this._excluded = state;
		if (state) {
			this.rootAccountGroupRowTemplate().addExcludedGroup(
				this.getAccountGroupId(),
			);
		} else {
			this.rootAccountGroupRowTemplate().removeExcludedGroup(
				this.getAccountGroupId(),
			);
		}
	}

	accept(visitor) {
		return visitor.visitGeneratedAccountGroupRowTemplate(this);
	}

	_instanceClass() {
		return GeneratedAccountGroupRow;
	}

	_interpretationSpec(interpreter) {
		const spec = super._interpretationSpec(...arguments);

		const coa = interpreter.getContext().getChartOfAccounts();

		const accountGroup = this._getAccountGroup(coa);

		spec.excluded =
			this._excludesAccountGroup(accountGroup, coa) ||
			accountGroup
				.getChildren()
				.every((group) => this._excludesAccountGroup(group, coa));

		return spec;
	}

	_excludesAccountGroup(accountGroup, chartOfAccounts) {
		return this._excludedGroupsIds.some((excludedGroupId) => {
			const excludedGroup = this._lookupAccountGroup(
				chartOfAccounts,
				excludedGroupId,
			);
			return excludedGroup.includes(accountGroup);
		});
	}

	static isVisible() {
		return false;
	}

	/**
	 * Create and return instances of the receiver, one for each group
	 * in `accountGroups`. The created row templates are registered as
	 * children of `parent`.
	 *
	 * @param {AbstractAccountGroup[]} accountGroups - Each of these
	 * account groups will be wrapped by a dedicated row template.
	 * @param {AbstractAccountGroupRowTemplate} parent - The row
	 * template which should contain the generated child row
	 * templates.
	 * @return {GeneratedAccountGroupRowTemplate[]}
	 */
	static makeRowTemplatesFromAccountGroups({ accountGroups, parent }) {
		return accountGroups.map((accountGroup) => {
			const accountGroupId = accountGroup.getId();

			return new this({
				id: `${parent.getId()}_${accountGroupId}`,
				accountGroupId,
				reportTemplate: parent.getReportTemplate(),
				parent,
				excludedGroupsIds: parent.getExcludedGroupsIds(),
			});
		});
	}
}
